import styled from "styled-components";

export const ModalPageContainer = styled.div`
  display: ${(props) => (props.visible ? "block" : "none")};
`;
